import PageWrapper from '@/shared/components/PageWrapper/PageWrapper';
import styles from './DataPrivacy.module.css';
import { Trans, useTranslation, withTranslation } from 'react-i18next';
import contactInformation from '@/shared/config/contactInformation';
import { IonRouterLink } from '@ionic/react';

const DataPrivacy: React.FC = () => {
  const { t } = useTranslation();

  return (
    <PageWrapper name="data-privacy-page" showFooter className={styles.page}>
      <h1>{t('data.privacy.title')}</h1>

      <section>
        <h2>{t('data.privacy.subtitle')}</h2>
        <p>{t('data.privacy.p1')}</p>

        <article>
          <h3>{t('data.privacy.q1')}</h3>
          <p>
            <Trans
              i18nKey="data.privacy.answer1"
              values={{
                websiteLabel: contactInformation.custodyWebsite.title,
                emailAddress: contactInformation.contact.title
              }}
              components={{
                website: <IonRouterLink href={contactInformation.custodyWebsite.url} target="_blank" />,
                email: <IonRouterLink href={contactInformation.contact.url} target="_blank" />
              }}
            />
          </p>
        </article>

        <article>
          <h3>{t('data.privacy.question2')}</h3>
          <p>
            <Trans
              i18nKey="data.privacy.answer2"
              values={{ emailAddress: contactInformation.dsb.title }}
              components={{ email: <IonRouterLink href={contactInformation.dsb.url} target="_blank" /> }}
            />
          </p>
        </article>

        <article>
          <h3>{t('data.privacy.legal.basis.processing')}</h3>
          <p>{t('data.privacy.legal.basis.processing.statement.p1')}</p>
          <p>{t('data.privacy.legal.basis.processing.statement.p2')} </p>
          <p>{t('data.privacy.legal.basis.processing.statement.contact')}</p>
          <p>{t('data.privacy.legal.basis.processing.statement.p3')} </p>
          <p>{t('data.privacy.legal.basis.processing.statement.p4')}</p>
        </article>

        <article>
          <h3>{t('data.privacy.third_parties')}</h3>
          <p>{t('data.privacy.third_parties.p1')}</p>
          <p>{t('data.privacy.third_parties.p2')}</p>
        </article>

        <article>
          <h3>{t('data.privacy.storage_duration')}</h3>
          <p>{t('data.privacy.storage_duration.p1')}</p>
        </article>

        <article>
          <h3>{t('data.privacy.use_of_cookies')}</h3>
          <p>{t('data.privacy.use_of_cookies.p1')}</p>
        </article>

        <article>
          <h3>{t('data.privacy.links')}</h3>
          <p>{t('data.privacy.links.p1')}</p>
        </article>

        <article>
          <h3>{t('data.privacy.place_of_processing')}</h3>
          <p>
            {t('data.privacy.place_of_processing.p1')}{' '}
            <IonRouterLink
              href="https://eur-lex.europa.eu/LexUriServ/LexUriServ.do?uri=OJ:L:2010:039:0005:0018:DE:PDF"
              target="_blank"
            >
              {t('data.privacy.place_of_processing.link')}
            </IonRouterLink>
            {t('data.privacy.place_of_processing.p1.part2')}
          </p>
        </article>

        <article>
          <h3>{t('data.privacy.rights')}</h3>
          <p>{t('data.privacy.rights.p1')}</p>
          <p>{t('data.privacy.rights.p2')}</p>
          <h4>{t('data.privacy.rights_access')}</h4>
          <p>{t('data.privacy.rights_access.p1')}</p>
          <h4>{t('data.privacy.rights_of_rectification')}</h4>
          <p>{t('data.privacy.rights_of_rectification.p1')}</p>
          <h4>{t('data.privacy.rights_of_erasure')}</h4>
          <p>{t('data.privacy.rights_of_erasure.p1')}</p>
          <h4>{t('data.privacy.rights_of_restriction')}</h4>
          <p>{t('data.privacy.rights_of_restriction.p1')}</p>
          <h4>{t('data.privacy.rights_portability')}</h4>
          <p>{t('data.privacy.rights_portability.p1')}</p>
          <h4>{t('data.privacy.rights_withdrawal')}</h4>
          <p>{t('data.privacy.rights_withdrawal.p1')}</p>
          <h4>{t('data.privacy.rights_objection')}</h4>
          <p>{t('data.privacy.rights_objection.p1')}</p>
          <p>{t('data.privacy.rights_objection.p2')}</p>
          <h4>{t('data.privacy.rights_complain')}</h4>
          <p>
            {t('data.privacy.rights_complain.p1')}{' '}
            <IonRouterLink href="mailto:poststelle@lfdi.bwl.de" target="_blank">
              {t('poststelle@lfdi.bwl.de')}
            </IonRouterLink>
            {t('data.privacy.rights_complain.website')}{' '}
            <IonRouterLink href="https://www.baden-wuerttemberg.datenschutz.de" target="_blank">
              {t('data.privacy.rights_complain.website.detail')}
            </IonRouterLink>
          </p>
        </article>

        <article>
          <h3>{t('data.privacy.rights_obligation')}</h3>
          <p>{t('data.privacy.rights_obligation.p1')}</p>
        </article>

        <article>
          <h3>{t('data.privacy.rights_automated_decision')}</h3>
          <p>{t('data.privacy.rights_automated_decision.p1')}</p>
        </article>

        <article>
          <h3>{t('data.privacy.rights_changes')}</h3>
          <p>{t('data.privacy.rights_changes.p1')}</p>
        </article>
      </section>

      <section>
        <h2>{t('data.privacy.cookie_notice')}</h2>
        <p>{t('data.privacy.cookie_notice.p1')}</p>
        <p>{t('data.privacy.cookie_notice.p2')} </p>
        <p>{t('data.privacy.cookie_notice.p3')} </p>
        <p>{t('data.privacy.cookie_notice.p4')} </p>
      </section>
    </PageWrapper>
  );
};

export default withTranslation()(DataPrivacy);
